<div class="component-wrapper">
  <div class="content-wrapper">
    <main>
      <h1>Varianzanalyse mit Messweiderholung (rmANOVA)</h1>
      <p>
        Eine ANOVA mit Messweiderholung gehört zu den multivariaten Verfahren,
        da hier mehrere Variablen auf Unterschiede untersucht werden. Ziel ist
        es signifikante Unterschiede zwischen z.B. Messzeitpunkten oder
        Messwiederholungen zu finden
      </p>
      <br />
      <br />

      <h2>Typ und Anwendung</h2>

      <p>
        Unterschiedsanalyse im Längsschnitt. Gibt es einen Unterschied der
        Mittelwerte (arithmetische Mittel) zwischen drei oder mehr als drei
        Variablen? Wie verändert sich ein Faktor oder Konstrukt über mehrere
        Messweiderholungen?
      </p>
      <br />
      <br />

      <h2>Beispiel</h2>

      <p>
        Gibt es eine Veränderung der Symptom Scores klinischer Patienten über 3
        Messzeitpunkte?
      </p>
      <br />
      <p>
        Welche Social Media Plattform (YouTube, TikTok, Reddit) wird am meisten
        genutzt?
      </p>
      <br />
      <p>
        Gibt es signifikante Unterschiede zwischen den Verkaufszahlen eines
        Unternehmens über 12 Monate hinweg?
      </p>
      <br /><br />

      <h2>Voraussetzungen</h2>
      <br />
      <br />

      <p>Metrische abhängige Variablen</p>
      <br />
      <p>
        Die Variablen müssen normalverteilt sein, es sei denn es sind >25
        Beobachtungen pro Messung
      </p>
      <br />
      <p>
        Es muss sich um eine abhängige stichprobe handeln, mit klar zuordenbaren
        Beobachtungen (Innersubjektivität)
      </p>
      <br />
      <p>Sphärizität gegeben (Mauchly-Test auf Sphärizität)</p>
      <br /><br />

      <p>
        Wir stellen an dieser Stelle jetzt ein Beispiel in SPSS und in R
        dar.p><br /><br />
      </p>

      <h2>Beispiel in SPSS</h2>
      <br />
      <br />

      <p>
        Gegeben sein ein einfacher Datensatz. Wir haben 30 Studierende befragt,
        auf welcher Social Media Plattform sie am meisten Zeit verbringen. Da
        jede Person somit 3 Werte besitzt, handelt es sich um eine abhängige
        Stichprobe im Längsschnitt. Wir haben zwar keine richtigen
        Messzeitpunkte aber im Grunde hat jede Person jede Angabe nacheinander
        gemacht. Jede Person besitzt also 3 werte. Die abhängige Variable ist
        somit die Social Media Plattform und die unabhängige Variable die
        Messwiederholung (Innersubjektfaktor), da jede Person, mit sich selbst
        verglichen wird
      </p>
      <br /><br />

      <img
        src="../../../assets/img/anover-wiederholt/ANOVA mit Messwiederholung SPSS wide format abhängige Stichprobe.png"
        alt="ANOVA mit Messwiederholung SPSS"
      />

      <p>
        Hier spricht man von wide format. Jede Plattform ist eine Variable,
        welche die durchschnittliche tägliche User Time in Stunden beinhaltet.
      </p>
      <br /><br />
      <img
        src="../../../assets/img/anover-wiederholt/ANOVA mit Messwiederholung SPSS long format abhängige Stichprobe.png"
        alt="ANOVA SPSS long"
      />
      <p>
        Hier spricht man von long format. Es gibt eine Stunden Variable mit
        allen Stunden und eine Plattformvariable. Die beobachten wiederholen
        sich also.
      </p>
      <br /><br />

      <p>
        Vorab können wir einige Voraussetzungen testen und die Daten deskriptiv
        Darstellen. Über -> Deskriptive Statistik -> Explorative Datenanalyse ->
        Diagramme -> Normalverteilungsdiagramme mit Test können wir den
        Shapiro-Wilk-Test auf Normalverteilung benutzen.
      </p>
      <br /><br />

      <img
        src="../../../assets/img/anover-wiederholt/ANOVA mit Messwiederholung SPSS deskritpive.png"
        alt="ANOVA mit Messwiederholung SPSS deskritpive"
      />

      <p>
        Hier können wir bereits deutliche Unterschiede in den Mittelwerten
        sehen.
      </p>
      <br /><br />

      <img
        src="../../../assets/img/anover-wiederholt/ANOVA mit Messwiederholung SPSS normalverteilung prüfen.png"
        alt="ANOVA mit Messwiederholung SPSS normalverteilung testen"
      />

      <p>
        Hier können wir sehen, dass die Stunden bei Reddit und Tiktok nicht
        normalverteilt sind. Laut Backhaus et al. (2021) ignorieren wir aber
        diese Verletzung, weil wir 30 Beobachtungen haben.
      </p>
      <br /><br />
      <img
        src="../../../assets/img/anover-wiederholt/ANOVA mit Messwiederholung SPSS Grafik.png"
        alt="ANOVA mit Messwiederholung SPSS Grafik"
      />

      <p>
        Auch im Grouped Boxplot können wir bereits deutliche Unterschiede in den
        Mittelwerten sehen.
      </p>
      <br /><br />

      <p>
        Über Analysieren->Allgemeines Lineares Modell->Messwiederholung können
        wir unser Modell bauen. Wichtig ist hier, dass die Daten im wide format
        vorliegen. Zuerst müssen wir einen Innersubjektfaktor bestimmen. Diesen
        würden wir hier einfach Plattform nennen und spezifizieren, dass dieser
        3 Stufen hat.
      </p>
      <br /><br />

      <img
        src="../../../assets/img/anover-wiederholt/Bild ANOVA mit Messwiederholung in SPSS  Innersubjekt.png"
        alt="ANOVA mit Messwiederholung in SPSS Innersubjekt"
      />

      <p>
        Als nächsten definieren wir diese. YouTube wird Level 1, TikTok Level 2
        und Reddit Level 3. Über Optionen können zudem die Deskriptive Statistik
        und die Effektstärken berechnen lassen. Unter Grafiken erstellen wir ein
        Line Plot mit dem Innersubjektfaktor auf der X-Achse und den
        durchschnittlichen Stunden auf der Y-Achse. Zudem müssen wir unter
        Geschätzte Radmittel noch den Post-Hoc-Test definieren, der jede
        Plattform mit jeder andern vergleicht.
      </p>
      <br /><br />

      <img
        src="../../../assets/img/anover-wiederholt/Bild ANOVA mit Messwiederholung in SPSS Post Hoc.png"
        alt="ANOVA mit Messwiederholung in SPSS Post Hoc"
      />

      <p>
        Zudem lebt Datenanalyse in SPSS von Grafiken, wir erstellen hier ein
        Liniendiagramm mit unserem Faktor Plattform auf der X-Achse
      </p>
      <br /><br />

      <img
        src="../../../assets/img/anover-wiederholt/ANOVA mit Messwiederholung SPSS Grafik.png"
        alt="ANOVA mit Messwiederholung in SPSS Grafik"
      />

      <p>Alternativ dazu können wir auch die SPSS Syntax benutzen.</p>
      <br /><br />

      <span style="color: rgb(0, 132, 255)">GLM </span
      ><span style="color: rgb(0, 0, 0)">YT TT R</span><br />

      <span style="color: rgb(0, 128, 28)">/WSFACTOR</span
      ><span style="color: rgb(0, 0, 0)">=Plattform 3 </span
      ><span style="color: rgb(255, 0, 0)">Polynomial</span><br />

      <span style="color: rgb(0, 128, 28)">/MEASURE</span
      ><span style="color: rgb(0, 0, 0)">=scale</span><br />

      <span style="color: rgb(0, 128, 28)">/METHOD</span
      ><span style="color: rgb(255, 0, 0)">=SSTYPE</span
      ><span style="color: rgb(0, 0, 0)">(3)</span><br />

      <span style="color: rgb(0, 128, 28)">/PRINT</span
      ><span style="color: rgb(0, 0, 0)">=</span
      ><span style="color: rgb(255, 0, 0)">DESCRIPTIVE </span><br />

      <span style="color: rgb(0, 128, 28)">/CRITERIA</span
      ><span style="color: rgb(0, 0, 0)">=</span
      ><span style="color: rgb(255, 0, 0)">ALPHA</span
      ><span style="color: rgb(0, 0, 0)">(.05) </span><br />

      <span style="color: rgb(0, 128, 28)">/WSDESIGN</span
      ><span style="color: rgb(0, 0, 0)">=Plattform</span>

      <p>
        Haben wir alles richtig gemacht, erhalten wir diesen Output, den wir
        weiter unten interpretieren.
      </p>
      <br /><br />

      <img
        src="../../../assets/img/anover-wiederholt/Bild ANOVA mit Messwiederholung in SPSS interpretieren.png"
        alt=""
      />
      <img
        src="../../../assets/img/anover-wiederholt/Bild ANOVA mit Messwiederholung in SPSS Grafik interpretieren.png"
        alt=""
      />

      <h2>Beispiel in R</h2>
      <br />
      <br />
      <p>
        Gegeben sein ein einfacher Datensatz. Wir haben 30 Studierende befragt,
        auf welcher Social Media Plattform sie am meisten Zeit verbringen. Da
        jede Person somit 3 Werte besitzt, handelt es sich um eine abhängige
        Stichprobe im Längsschnitt. Wir haben zwar keine richtigen
        Messzeitpunkte aber im Grunde hat jede Person jede Angabe nacheinander
        gemacht. Jede Person besitzt also 3 werte. Die abhängige Variable ist
        somit die Social Media Plattform und die unabhängige Variable die
        Messwiederholung (Innersubjektfaktor), da jede Person, mit sich selbst
        verglichen wird. In R gestaltet sich das Ganze ein wenig schwieriger.
        Den Code haben wir euch an dieser Stelle in der Konsole zur Verfügung
        gestellt.
      </p>
      <br /><br />
      <iframe
        width="100%"
        height="300"
        src="https://rdrr.io/snippets/embed/?code=%23%23packages%0A%0Alibrary(tidyverse)%0Alibrary(ggpubr)%0Alibrary(rstatix)%0Alibrary(hrbrthemes)%0Alibrary(viridis)%0Alibrary(extrafont)%0A%0A%23%23rmANOVA%0A%0A%23%23create%20Data%0A%0Adata%3C-data.frame(ID%3Dc(1%3A30)%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20YT%3Dc(3%2C2%2C3%2C2%2C4%2C5%2C2%2C3%2C2%2C1%2C0%2C0%2C2%2C1%2C0%2C2%2C3%2C1%2C2%2C4%2C3%2C2%2C4%2C3%2C2%2C5%2C4%2C2%2C3%2C1)%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20TT%3Dc(5%2C4%2C5%2C6%2C4%2C5%2C3%2C5%2C6%2C7%2C6%2C5%2C4%2C5%2C3%2C4%2C3%2C5%2C6%2C5%2C0%2C1%2C0%2C4%2C5%2C6%2C5%2C4%2C6%2C7)%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20R%3Dc(0%2C0%2C0%2C0%2C1%2C2%2C1%2C0%2C0%2C3%2C0%2C0%2C5%2C0%2C0%2C1%2C1%2C2%2C1%2C3%2C1%2C0%2C0%2C1%2C2%2C3%2C1%2C2%2C1%2C2))%0A%0A%23%23describe%0A%0Afor%20(i%20in%20c(2%3A4))%0A%7B%0A%20print(psych%3A%3Adescribe(data%5B%2Ci%5D))%0A%20print(shapiro.test(data%5B%2Ci%5D))%0A%7D%0A%0A%23%23rmANOVA%0A%23%23%23transfom%20to%20long%20format%0A%0Adata_long%20%3C-%20data%20%25%3E%25%0A%20%20gather(key%20%3D%20%22Plattform%22%2C%20value%20%3D%20%22Stunden%22%2C%20YT%2C%20TT%2C%20R)%20%25%3E%25%0A%20%20convert_as_factor(ID%2C%20Plattform)%0A%0A%23%23%23graphic%0A%0Adata_long%20%25%3E%25%0A%20%20ggplot(%20aes(x%3DPlattform%2C%20y%3DStunden%2C%20fill%3DPlattform))%20%2B%0A%20%20geom_boxplot()%20%2B%0A%20%20scale_fill_viridis(discrete%20%3D%20TRUE%2C%20alpha%3D0.6)%20%2B%0A%20%20geom_jitter(color%3D%22black%22%2C%20size%3D0.4%2C%20alpha%3D0.9)%20%2B%0A%20%20theme_ipsum()%20%2B%0A%20%20theme(%0A%20%20%20%20legend.position%3D%22none%22%2C%0A%20%20%20%20plot.title%20%3D%20element_text(size%3D11)%0A%20%20)%20%2B%0A%20%20ggtitle(%22Stunden%20nach%20Plattform%22)%20%2B%0A%20%20xlab(%22Plattform%22)%0A%0A%23%23%23rmANOVA%0A%0Ares.aov%20%3C-%20anova_test(%0A%20%20data%20%3D%20data_long%2C%20dv%20%3D%20Stunden%2C%20wid%20%3D%20ID%2C%0A%20%20within%20%3D%20c(Plattform)%0A)%0Aget_anova_table(res.aov)%0A%0A%23%23%23Groupwise%20Comparison%0A%0Apwc%20%3C-%20data_long%20%25%3E%25%0A%20%20pairwise_t_test(%0A%20%20%20%20Stunden%20~%20Plattform%2C%20paired%20%3D%20TRUE%2C%0A%20%20%20%20p.adjust.method%20%3D%20%22BH%22%0A%20%20)%0Apwc"
        frameborder="0"
      ></iframe>

      <p>
        Zunächst laden wir die Daten und erstellen eine Deskriptive Statistik
        mit Test auf Normalverteilung. Anschließend müssen die Daten in das long
        format transformiert werden. Hier sehen bereits deutliche Unterschiede
        zwischen den Plattformen.
      </p>
      <br /><br />

      <img
        src="../../../assets/img/anover-wiederholt/ANOVA mit Messwiederholung R deskritpive.png"
        alt="ANOVA mit Messwiederholung R deskritpive "
      />
      <img
        src="../../../assets/img/anover-wiederholt/ANOVA mit Messwiederholung R Grafik.png"
        alt="ANOVA mitMesswiederholung R Grafik"
      />

      <p>
        Anschließend können wir die ANOVA mit Messwiederholung und den paarweise
        Vergleich mit Bonferroni-Holm Korrektur durchführen.
      </p>
      <br /><br />

      <img
        src="../../../assets/img/anover-wiederholt/ANOVA mit Messwiederholung Ergebnisse interpretieren.png"
        alt="ANOVA mit Messwiederholung Ergebnisse interpretieren"
      />

      <h2>Interpretation</h2>
      <br />
      <br />
      <p>
        Die Interpretation der ANOVA mit Messwiederholung ist hingegen relativ
        einfach. Im Modell zeigen sich signifikanten Unterschiede
        (F(1.67,48.37)=42.936, p&lt;.001, ETAg²=.481). Nach Cohen (1992) kann
        hier von einem sehr starken Effekt gesprochen werden (f=.960). Bei der
        Überprüfung der paarweisen Vergleiche zeigen sich signifikante
        Unterschiede zwischen allen Plattformen. Während TikTok (M=4.47,
        SD=1.76) am häufigsten genutzt wird, liegt Reddit auf dem letzten Platz
        (M=1.10, SD=1.24) und YouTube (2.37, SD=1.35) dazwischen.
      </p>
      <br /><br />

      <p>
        Fragen, Probleme, Anmerkungen? Dann schreib und einfach und wir helfen
        dir sehr gerne weiter.
      </p>
      <br /><br />

      <div class="button" routerLink="/kostenloses-erstgepraech">
        <span>Kostenloses Erstgespräch</span>
      </div>

      <p>Dein Team von Hanseatic-Statistics.</p>
      <br /><br />

      <p>
        Quellen: Bortz, J. & Döring, N. (2016). Forschungsmethoden und
        Evaluation für Human- und Sozialwissenschaftler. 5. Auflage. Heidelberg:
        Springer. Backhaus, K., Erichson, B., Plinke, W. & Weiber, R. (2016).
        Multivariate Analysemethoden. Eine anwendungsorientierte Einführung. 14.
        Auflage. Berlin: Springer. Hirsig, R. (2006a). Statistische Methoden in
        den Sozialwissenschaften. Eine Einführung im Hinblick auf
        computergestützte Datenanalysen mit SPSS. Band I. 5. Auflage. Zürich:
        Seismo. .
      </p>
      <br /><br />
    </main>
  </div>
</div>
